import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { GeneralAgent } from '@/modules/GeneralAgent/interfaces/general-agent'
import { ApolloResponse } from '@/interfaces/apollo'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'
import { tablePerPageOptions } from '@/utils/tablePerPageOptions'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppSearch from '@/components/AppSearch.vue'
import AppRefresh from '@/components/AppRefresh.vue'
import AppTextField from '@/components/AppTextField.vue'
import generalAgentDialog from '@/modules/GeneralAgent/scripts/general-agent-dialog'
import { getGeneralAgents, editGeneralAgent } from '@/modules/GeneralAgent/gql/general-agent.gql'

@Component({
  components: {
    AppBreadcrumbs,
    AppSearch,
    AppRefresh,
    AppTextField
  }
})
export default class GeneralAgentList extends mixins(generalAgentDialog) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Setting'
    },
    {
      text: 'GeneralAgents'
    }
  ]
  searchVal = ''

  generalAgents: GeneralAgent[] = []

  orderBy: {
    [key: string]: string
  } = {
    id: 'ID',
    name: 'NAME'
  }

  renaming = false
  nullGeneralAgentName = false
  renameGeneralAgentName = ''

  tableColumn = [
    { field: 'name', title: 'GeneralAgent Name', sortable: true, slots: { default: 'name_default' } },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 112 }
  ]

  tableOptions = {
    loading: false,
    tablePage: tablePerPageOptions(),
    sortBy: 'id',
    sortDesc: true
  }

  mounted () {
    this.getGeneralAgents()
  }

  async getGeneralAgents () {
    const { sortBy, sortDesc, tablePage } = this.tableOptions
    const { currentPage, pageSize } = tablePage
    const searchVal = this.searchVal ? this.searchVal : null
    const orderBy = this.orderBy[sortBy] || 'ID'
    const asc = sortDesc || false
    this.tableOptions.loading = true
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getGeneralAgents,
        variables: {
          filter: {
            name: searchVal
          },
          order: {
            orderBy: orderBy,
            asc: !asc
          },
          paging: {
            offset: (currentPage - 1) * pageSize,
            limit: pageSize
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.generalAgents = result.data.getGeneralAgents.generalAgents
      this.tableOptions.loading = false
      this.tableOptions.tablePage.total = result.data.getGeneralAgents.paging.totalCount
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  renameGeneralAgent (e: Event, item: any) {
    e.preventDefault()
    e.stopPropagation()
    this.targetGeneralAgent = Object.assign({}, item)
    this.renameGeneralAgentName = item.name
    this.renaming = true
  }

  stopPreventDefault (e: Event) {
    e.preventDefault()
    e.stopPropagation()
  }

  async renameConfirm (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.nullGeneralAgentName = !this.renameGeneralAgentName
    if (this.nullGeneralAgentName) {
      return
    }
    await this.renameGeneralAgentNameConfirm()
    this.renaming = false
  }

  async renameCancel (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.renaming = false
    this.renameGeneralAgentName = ''
  }

  async renameGeneralAgentNameConfirm () {
    if (!this.targetGeneralAgent) {
      return
    }
    const { id } = this.targetGeneralAgent
    try {
      await this.$apollo.mutate({
        mutation: editGeneralAgent,
        variables: {
          generalAgentId: Number(id),
          generalAgentInput: {
            name: this.renameGeneralAgentName
          }
        }
      })
      showNotification({
        msg: 'Update the general-agent name successfully',
        type: SnackType.Success
      })
      this.getGeneralAgents()
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  refreshList () {
    this.searchVal = ''
    this.getGeneralAgents()
  }

  async deleteGeneralAgentConfirm () {
    await this.deleteGeneralAgentPost()
    this.getGeneralAgents()
  }

  routeToDetail (item: any) {
    return {
      name: 'GeneralAgentDetailDetail',
      params: {
        id: item.id
      }
    }
  }

  sortTable (column: any) {
    this.tableOptions.sortBy = column.property
    this.tableOptions.sortDesc = column.order === 'desc'
    this.getGeneralAgents()
  }

  handlePageChange (pageData: any) {
    this.tableOptions.tablePage.currentPage = pageData.currentPage
    this.tableOptions.tablePage.pageSize = pageData.pageSize
    this.getGeneralAgents()
  }
}
